export default __webpack_public_path__ + "static/media/pedestrian.a6b1d5a9.svg";